<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>jackpot-trigger</ion-title>
  </ion-toolbar>
</ion-header> -->
<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col>
        <!-- Main content wrapper starts here -->
        <div class="ion-align-self-center main-container">
          <ion-text>
            <!-- App heading -->
            <h1>Confirm Activation</h1>
          </ion-text>
          <!-- closed here -->
          <div class="ion-text-center jackpot-img"><img src="assets/images/jackpot-img.jpg" alt="Success" /></div>
          <!--  Image -->

          <ion-text class="never_miss">
            <!-- App content -->
            <h2 class="sub-heading">Never Miss A Big Jackpot!</h2>
            <p class="jackpot-content">
              Get {{ jackpotTrigger?.lines }} EuroMillions Lines in Every Draw when jackpot reaches £{{
                jackpotTrigger?.jackpot
              }}
              until its won. For <span class="medium-txt">Only £{{ jackpotTrigger?.price }}</span> per draw.
            </p>
            <p class="italic-font">
              NB. This will be on top of any existing packages - giving you an EXTRA boost when the jackpot is high. Or
              for Members who just want to be in BIG Jackpots Only.
            </p>
            <p class="jackpot-content">Pause and Reactivate this service at any time.</p>
          </ion-text>
          <!-- closed here -->

          <p class="ion-text-center trigger-text">
            <span class="medium-txt">£{{ jackpotTrigger?.price }}</span> trigger
          </p>
          <!-- App button starts here -->
          <ion-button (click)="makePayment()" class="button-1" expand="block" [disabled]="!isOnline"
            >Activate</ion-button
          >
          <p class="no-thanks" (click)="navigateToRegistrationDefault()">No thanks</p>
        </div>
        <!-- Main content wrapper closed here -->
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
